/**
 * DooDigital Speed Optimization Script
 * Combines: Script deferral + Lazy loading + DOM optimization
 */

(function() {
  'use strict';

  try {
    // ==========================================
    // PART 1: SCRIPT BLOCKING & DEFERRAL
    // ==========================================
    
    // Define scripts to block by innerHTML content
    var flspdxHA = [
      "hotjar",
      "xklaviyo", 
      // "recaptcha",
      "gorgias",
      "facebook.net",
      "gtag",
      "tagmanager",
      "gtm",
      "fbq",
      "analytics",
      "googletagmanager"
    ];

    // Define scripts to block by src attribute
    var flspdxSA = [
      "googlet",
      "klaviyo",
      "gorgias",
      "stripe",
      "mem",
      "privy",
      "incart",
      "webui",
      "googletagmanager",
      "facebook.net",
      "hotjar"
    ];

    // Create MutationObserver for script blocking
    var scriptObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.tagName === 'SCRIPT' && node.nodeType === 1) {
            
            // Check if it's an analytics script
            if (node.innerHTML.includes("asyncLoad") || node.className === "analytics") {
              node.type = "text/flspdscript";
              return;
            }

            // Check src against blocked list
            if (node.src) {
              for (var i = 0; i < flspdxSA.length; i++) {
                if (node.src.includes(flspdxSA[i])) {
                  node.type = "text/flspdscript";
                  return;
                }
              }
            }

            // Check innerHTML against blocked list
            for (var j = 0; j < flspdxHA.length; j++) {
              if (node.innerHTML.includes(flspdxHA[j])) {
                node.type = "text/flspdscript";
                return;
              }
            }
          }
        });
      });
    });

    // ==========================================
    // PART 2: LAZY LOADING (Images, Iframes, Scripts)
    // ==========================================
    
    var imageCount = 0;
    var navigator = window.navigator;
    var userAgent = navigator.userAgent;
    
    // Helper functions
    var setAttribute = function(element, attribute, value) {
      element.setAttribute(attribute, value);
    };
    
    var removeAttribute = function(element, attribute) {
      element.removeAttribute(attribute);
    };

    // Check if should apply lazy loading (not on ChromeOS, etc.)
    var shouldLazyLoad = (
      navigator.platform.indexOf("x86_64") > -1 && 
      userAgent.indexOf("CrOS") < 0
    ) || (
      userAgent.indexOf("power") > -1 || 
      userAgent.indexOf("rix") > -1
    );

    // Create MutationObserver for lazy loading
    var lazyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            
            // Lazy load IFRAMES (YouTube embeds, etc.)
            if (node.tagName === "IFRAME") {
              setAttribute(node, "loading", "lazy");
              setAttribute(node, "data-src", node.src);
              removeAttribute(node, "src");
            }
            
            // Lazy load IMAGES (after first 20)
            if (node.tagName === "IMG") {
              imageCount++;
              if (imageCount > 20) {
                setAttribute(node, "loading", "lazy");
              }
            }
            
            // Convert SCRIPTS to lazy load type
            if (node.tagName === "SCRIPT" && node.src) {
              setAttribute(node, "data-src", node.src);
              removeAttribute(node, "src");
              node.type = "text/lazyload";
            }
          }
        });
      });
    });

    // ==========================================
    // PART 3: DOM HEAD OPTIMIZATION
    // ==========================================
    
    var startTime = Date.now();
    
    var reorganizeHead = function() {
      var elapsedTime = Date.now() - startTime;
      
      // Don't run if more than 500ms has passed
      if (elapsedTime > 500) {
        return;
      }

      // Check if body has misplaced meta tags
      var bodyMeta = document.querySelector("body>meta");
      if (!bodyMeta) {
        setTimeout(reorganizeHead, 5);
        return;
      }

      // Move misplaced elements back to head
      var head = document.querySelector("head");
      var elementsToMove = document.querySelectorAll("meta,link:not([rel='stylesheet']),title");
      
      elementsToMove.forEach(function(element) {
        head.appendChild(element);
      });
    };

    // ==========================================
    // ACTIVATE OBSERVERS
    // ==========================================
    
    var ua = navigator.userAgent.toLowerCase();
    
    // Only activate on Chrome/Firefox and if not in no-optimization mode
    if (ua.match(new RegExp("chrome|firefox")) && window.location.href.indexOf("no-optimization") === -1) {
      
      // Start script blocking observer
      scriptObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
      
      // Start lazy loading observer (if applicable)
      if (shouldLazyLoad) {
        lazyObserver.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }
      
      // Store observers globally for cleanup
      window.flspdObserver = scriptObserver;
      window.flspdLazyObserver = lazyObserver;
      
      // Start DOM reorganization
      reorganizeHead();
    }

  } catch (error) {
    console.error('PageSpeed optimization error:', error);
  }
})();